// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._001Dq {\n  width: 240px;\n}\n\n._9iyhh {\n  width: 100%;\n}\n\n.bCCE5 {\n  padding-left: var(--spacing-sm);\n}\n\n._001Dq input {\n  padding: 8.5px var(--spacing-sm) 8.5px 0;\n}\n\n.tNYw\\+ {\n  opacity: 50%;\n}\n\n.e4H8d input {\n  padding-left: var(--spacing-xs);\n}\n\n.SjRRJ {\n  white-space: nowrap;\n}\n\n.Ag2r9 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin: var(--spacing-xxs) var(--spacing-xs) 0;\n}\n\n.g0bf3 {\n  position: absolute;\n  bottom: calc(var(--spacing-xt-sm)*-1);\n  right: 0;\n  background: var(--color-white);\n}\n\n._001Dq .MuiFormLabel-root.MuiInputLabel-root {\n  background-color: var(--color-white);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_001Dq",
	"fullWidth": "_9iyhh",
	"outlinedInputRoot": "bCCE5",
	"rootLoading": "tNYw+",
	"rootWithStartAdornment": "e4H8d",
	"label": "SjRRJ",
	"helperTextBox": "Ag2r9",
	"compactCharLimit": "g0bf3"
};
export default ___CSS_LOADER_EXPORT___;
